import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// guest chat
const GuestChatPage = Loadable(lazy(() => import('views/pages/guest-chat')));

// auth flow routing
const AuthCheckMail1 = Loadable(lazy(() => import('views/pages/authentication/authentication1/CheckMail1')));
const AuthResetPassword1 = Loadable(lazy(() => import('views/pages/authentication/authentication1/ResetPassword1')));
const AuthCodeVerification1 = Loadable(lazy(() => import('views/pages/authentication/authentication1/CodeVerification1')));

// maintenance routing
const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));
const MaintenanceComingSoon1 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon1')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));

// public pages routing
const PagesLanding = Loadable(lazy(() => import('views/pages/landing')));
const PagesContactUS = Loadable(lazy(() => import('views/pages/contact-us')));
const PagesFaqs = Loadable(lazy(() => import('views/pages/saas-pages/Faqs')));
const PagesPrivacyPolicy = Loadable(lazy(() => import('views/pages/saas-pages/PrivacyPolicy')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        // Legacy /pages/* redirects
        { path: '/pages/login', element: <Navigate to="/login" replace /> },
        { path: '/pages/superadmin/login', element: <Navigate to="/login" replace /> },
        { path: '/pages/register', element: <Navigate to="/register" replace /> },
        { path: '/pages/forgot-password/forgot-password1', element: <Navigate to="/forgot-password" replace /> },
        { path: '/pages/check-mail/check-mail1', element: <Navigate to="/check-mail" replace /> },
        { path: '/pages/reset-password/reset-password1', element: <Navigate to="/reset-password" replace /> },
        { path: '/pages/code-verification/code-verification1', element: <Navigate to="/code-verification" replace /> },
        { path: '/pages/error', element: <Navigate to="/error" replace /> },
        { path: '/pages/coming-soon1', element: <Navigate to="/coming-soon" replace /> },
        { path: '/pages/coming-soon2', element: <Navigate to="/coming-soon" replace /> },
        { path: '/pages/under-construction', element: <Navigate to="/under-construction" replace /> },
        { path: '/pages/landing', element: <Navigate to="/landing" replace /> },
        { path: '/pages/contact-us', element: <Navigate to="/contact-us" replace /> },
        { path: '/pages/faqs', element: <Navigate to="/faqs" replace /> },
        { path: '/pages/privacy-policy', element: <Navigate to="/privacy-policy" replace /> },

        // Clean URLs
        { path: '/check-mail', element: <AuthCheckMail1 /> },
        { path: '/reset-password', element: <AuthResetPassword1 /> },
        { path: '/code-verification', element: <AuthCodeVerification1 /> },
        { path: '/error', element: <MaintenanceError /> },
        { path: '/coming-soon', element: <MaintenanceComingSoon1 /> },
        { path: '/under-construction', element: <MaintenanceUnderConstruction /> },
        { path: '/landing', element: <PagesLanding /> },
        { path: '/contact-us', element: <PagesContactUS /> },
        { path: '/faqs', element: <PagesFaqs /> },
        { path: '/privacy-policy', element: <PagesPrivacyPolicy /> },
        { path: '/ai-assistant', element: <GuestChatPage /> }
    ]
};

export default AuthenticationRoutes;
